import React from "react";
import PropTypes from "prop-types";
import BloombergBanner from "../v3/bloomberg-banner/BloombergBanner";
import Footer from "../footer/Footer";

const FullWidthLayout = ({ bloombergSiteUrl, children }) => {
    return (
        <React.Fragment>
            <BloombergBanner bloombergSiteUrl={ bloombergSiteUrl } pathname="" />
            <main className="full-width-layout">
                { children }
                <Footer bloombergSiteUrl={ bloombergSiteUrl } />
            </main>
        </React.Fragment>
    );
};

FullWidthLayout.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default FullWidthLayout;
